import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Componente de loading moderno usado pelo block-ui no interceptor de requests.
 * Respeita blockLoading: quando o header 'blockLoading' está presente na request,
 * o interceptor não chama blockUI.start(), então este componente não é exibido.
 */
@Component({
  selector: 'app-global-loading',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="global-loading">
      <div class="global-loading__card">
        <div class="global-loading__spinner">
          <span class="global-loading__dot"></span>
          <span class="global-loading__dot"></span>
          <span class="global-loading__dot"></span>
        </div>
        <p class="global-loading__message" *ngIf="message">{{ message }}</p>
        <p class="global-loading__message global-loading__message--default" *ngIf="!message">
          Carregando...
        </p>
      </div>
    </div>
  `,
  styles: [`
    .global-loading {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: none;
    }

    .global-loading__card {
      background: rgba(255, 255, 255, 0.98);
      border-radius: 16px;
      padding: 2rem 2.5rem;
      box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.04);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1.25rem;
      min-width: 200px;
      backdrop-filter: blur(12px);
    }

    .global-loading__spinner {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
    }

    .global-loading__dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: linear-gradient(135deg, #002a61 0%, #004a9e 100%);
      animation: global-loading-bounce 0.6s ease-in-out infinite both;
    }

    .global-loading__dot:nth-child(1) { animation-delay: 0s; }
    .global-loading__dot:nth-child(2) { animation-delay: 0.15s; }
    .global-loading__dot:nth-child(3) { animation-delay: 0.3s; }

    @keyframes global-loading-bounce {
      0%, 80%, 100% { transform: scale(0.75); opacity: 0.6; }
      40% { transform: scale(1.15); opacity: 1; }
    }

    .global-loading__message {
      margin: 0;
      font-size: 0.9rem;
      font-weight: 500;
      color: #002a61;
      letter-spacing: 0.01em;
    }

    .global-loading__message--default {
      color: #5a6c7d;
    }
  `]
})
export class GlobalLoadingComponent {
  /** Mensagem exibida abaixo do spinner (injetada pelo block-ui quando passado no start()). */
  @Input() message?: any;
}
